
import { useTaskContext } from "hooks/tasks";
import { NoteList } from "components/notes";
import { INote } from "models/notes";
import { useAddWorkItemNote, useWorkItemNotes } from "hooks/work-items";
import { useUpdateNote } from "hooks/notes";



const Notes = () => {
    const taskContext = useTaskContext();

    const [ 
        notes,
        count,
        handleRefresh,
        loading,
        error
    ] = useWorkItemNotes(taskContext.task?.workItem.id ?? -1);

    const addWorkItemNote = useAddWorkItemNote(taskContext.task?.workItem.id ?? -1, handleRefresh);
    const updateNote = useUpdateNote(handleRefresh);

    const mock: INote[] = [
        { 
            id: 1,
            username: 'Esayas Beshah',
            userInitials: 'EB',
            note: '@JaniceLong, dolor sit amet consectetur. Sed lorem iaculis ut tortor tellus pretium lectus. Dolor nibh amet congue proin mauris. Scelerisque praesent magna egestas volutpat mi iaculis id morbi libero. volutpat mi iaculis id morbi libero.i iaculis id morbi',
            isUserNote: false,
            isFocused: true,            
            createdOn: '2024-01-23T03:43:00',
            children: [
                {
                    id: 4,
                    username: 'Danny Helms',
                    userInitials: 'DH',
                    note: 'Lorem ipsum dolor sit amet consectetur. Malesuada id risus venenatis massa hac nibh ullamcorper urna. Ullamcorper ultricies dui quam in. Tempus curabitur et ',
                    isUserNote: true,
                    createdOn: '2024-01-23T04:53:00'
                },
                {
                    id: 5,
                    username: 'Esayas Beshah',
                    userInitials: 'EB',
                    note: 'This is Integra’s response to Amelia’s note.',
                    isUserNote: false,
                    isFocused: true,
                    createdOn: '2024-01-23T04:53:00'
                }
            ]
        },
        { 
            id: 2,
            username: 'Danny Helms',
            userInitials: 'DH',
            note: '@JamesFitchett bsit amet, consectetur adipiscing elit. Tristique orci enim, risus nisi, enim in cras. Consectetur accumsan, sed vitae leo ante.    ',
            isUserNote: true,
            createdOn: '2024-01-22T05:20:00',
            children: [
                {
                    id: 6,
                    username: 'Esayas Beshah',
                    userInitials: 'EB',
                    note: 'test something note 2',
                    isDeleted: true,            
                    isUserNote: false,
                    createdOn: '2024-01-22T05:20:00'
                },
                {
                    id: 7,
                    username: 'Danny Helms',
                    userInitials: 'DH',
                    note: 'Dolor sit amet consectetur. Sed lorem iaculis ut tortor tellus pretium lectus. Dolor nibh amet congue proin mauris. Scelerisque praesent magna egestas volutpat mi iaculis id morbi libero. volutpat mi iaculis id morbi libero.i iaculis id morbi',
                    isDeleted: false,      
                    isUserNote: true,
                    createdOn: '2024-01-22T05:20:00'
                }
            ]
        },
        { 
            id: 3,
            username: 'Esayas Beshah',
            userInitials: 'EB',
            note: 'test something note 2',
            isDeleted: true,            
            isUserNote: true,
            createdOn: '2024-01-22T05:20:00'
        }
    ];

    return (
        <NoteList notes={notes} loading={loading} 
            onRefresh={handleRefresh}
            onAdd={addWorkItemNote}
            onUpdate={updateNote}
        /> 
    );
};

export default Notes;